(function () {
  var SMILE_LAUNCHER_SELECTOR =
    '#smile-ui-lite-launcher-frame-container, .smile-launcher-frame-container';
  var VIP_LAUNCHER_BTN_IDS = ['geeko-vip-launcher', 'geeko-vip-launcher-drawer'];
  var CHAT_LAUNCHER_BTN_IDS = ['geeko-chat-launcher', 'geeko-chat-launcher-drawer'];
  var smileWatchStarted = false;
  var smileDedupeTimer = null;
  var vipClickBound = false;

  function syncHeaderIconSizeVar() {
    var ref =
      document.querySelector('.header__search .header__icon .icon:not(.icon-close)') ||
      document.querySelector('[id^="geeko-vip-launcher"] .icon-geeko-crown');
    if (!ref) return;
    var w = ref.getBoundingClientRect().width;
    if (w > 0) {
      document.documentElement.style.setProperty('--geeko-header-icon-size', w + 'px');
    }
  }

  function hasSmilePanelApi() {
    return (
      typeof window.SmileUI !== 'undefined' &&
      typeof window.SmileUI.openPanel === 'function'
    );
  }

  function runSmile(fn) {
    if (!hasSmilePanelApi()) return false;
    try {
      if (window.SmileUI.ready && typeof window.SmileUI.ready.then === 'function') {
        window.SmileUI.ready().then(fn).catch(fn);
      } else {
        fn();
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function openSmileRewardsPanel(deepLink) {
    return runSmile(function () {
      try {
        var opts = deepLink ? { deep_link: deepLink } : undefined;
        window.SmileUI.openPanel(opts);
      } catch (e) {}
    });
  }

  function onSmileUiReady(fn) {
    if (document.body.classList.contains('geeko-smile-ui-ready') && hasSmilePanelApi()) {
      runSmile(fn);
      return;
    }

    if (hasSmilePanelApi()) {
      runSmile(fn);
      return;
    }

    var settled = false;
    function settle() {
      if (settled) return;
      settled = true;
      runSmile(fn);
    }

    document.addEventListener('geeko-smile-ui-ready', settle, { once: true });
    document.addEventListener('smile-ui-loaded', settle, { once: true });

    var n = 0;
    var id = setInterval(function () {
      if (hasSmilePanelApi()) {
        clearInterval(id);
        settle();
      } else if (++n > 150) {
        clearInterval(id);
      }
    }, 100);
  }

  function syncVipLauncherVisibility() {
    var hasLauncher = document.querySelectorAll(SMILE_LAUNCHER_SELECTOR).length > 0;
    var smileReady = document.body.classList.contains('geeko-smile-ui-ready');
    document.body.classList.toggle('geeko-vip-present', hasLauncher || smileReady);
    window.dispatchEvent(new Event('resize'));
  }

  function runZendesk(fn) {
    if (typeof zE !== 'function') return false;
    try {
      zE(function () {
        fn();
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  function openZendeskChat() {
    return runZendesk(function () {
      try {
        zE('messenger', 'show');
      } catch (e) {}
      try {
        zE('messenger', 'open');
      } catch (e) {}

      try {
        zE('webWidget', 'show');
      } catch (e) {}
      try {
        zE('webWidget', 'open');
      } catch (e) {}
    });
  }

  function hideZendeskLauncher() {
    runZendesk(function () {
      try {
        zE('messenger', 'hide');
      } catch (e) {}
    });
  }

  function onZendeskReady(fn) {
    if (typeof zE !== 'function') {
      var n = 0;
      var id = setInterval(function () {
        if (typeof zE === 'function') {
          clearInterval(id);
          runZendesk(fn);
        } else if (++n > 100) {
          clearInterval(id);
        }
      }, 100);
      return;
    }
    runZendesk(fn);
  }

  function clickNativeLauncherFallback() {
    var launcher =
      document.querySelector('iframe#launcher') ||
      document.querySelector('[data-testid="launcher-frame"]') ||
      document.querySelector('div[role="button"][aria-label*="Chat"]');
    if (!launcher) return false;
    try {
      launcher.contentWindow && launcher.contentWindow.document
        ? launcher.contentWindow.document.body.click()
        : launcher.click();
    } catch (e) {
      launcher.click();
    }
    return true;
  }

  function isSmileLauncherNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.id === 'smile-ui-lite-launcher-frame-container') return true;
    if (node.classList && node.classList.contains('smile-launcher-frame-container')) {
      return true;
    }
    if (!node.querySelector) return false;
    return !!node.querySelector(SMILE_LAUNCHER_SELECTOR);
  }

  function scheduleSmileDedupe() {
    clearTimeout(smileDedupeTimer);
    smileDedupeTimer = setTimeout(syncVipLauncherVisibility, 150);
  }

  function watchSmileLauncher() {
    if (smileWatchStarted) return;
    smileWatchStarted = true;

    syncVipLauncherVisibility();
    document.addEventListener('geeko-smile-ui-ready', syncVipLauncherVisibility);

    if (typeof MutationObserver === 'undefined') return;

    var mutationObserver = new MutationObserver(function (mutations) {
      var relevant = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type !== 'childList') continue;
        var nodes = []
          .concat(Array.prototype.slice.call(m.addedNodes))
          .concat(Array.prototype.slice.call(m.removedNodes));
        for (var j = 0; j < nodes.length; j++) {
          if (isSmileLauncherNode(nodes[j])) {
            relevant = true;
            break;
          }
        }
        if (relevant) break;
      }
      if (relevant) scheduleSmileDedupe();
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function bindLauncherButtons(ids, onClick) {
    ids.forEach(function (id) {
      var btn = document.getElementById(id);
      if (!btn || btn.dataset.geekoLauncherBound === 'true') return;
      btn.dataset.geekoLauncherBound = 'true';
      btn.addEventListener('click', onClick);
    });
  }

  function initVip() {
    if (vipClickBound) return;
    vipClickBound = true;

    bindLauncherButtons(VIP_LAUNCHER_BTN_IDS, function (e) {
      e.preventDefault();
      e.stopPropagation();

      var opened = openSmileRewardsPanel();
      if (!opened) {
        onSmileUiReady(function () {
          if (!openSmileRewardsPanel()) {
            console.warn('[geeko-vip] SmileUI not ready — check publishable key / initialization');
          }
        });
      }
    });
  }

  function initChat() {
    onZendeskReady(hideZendeskLauncher);

    bindLauncherButtons(CHAT_LAUNCHER_BTN_IDS, function (e) {
      e.preventDefault();
      e.stopPropagation();

      var opened = openZendeskChat();
      if (!opened) {
        onZendeskReady(function () {
          if (!openZendeskChat()) {
            clickNativeLauncherFallback();
            console.warn('[geeko-chat] Zendesk not ready, tried fallback');
          }
        });
      }
    });
  }

  function init() {
    syncHeaderIconSizeVar();
    window.addEventListener('resize', syncHeaderIconSizeVar, { passive: true });
    initVip();
    watchSmileLauncher();
    initChat();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
